import $ from 'jquery';
import 'jquery-ui/ui/version.js';
import 'jquery-ui/ui/data.js';
import 'jquery-ui/ui/plugin.js';
import 'jquery-ui/ui/safe-active-element.js';
import 'jquery-ui/ui/safe-blur.js';
import 'jquery-ui/ui/effect.js';
import 'jquery-ui/ui/widget.js';
import 'jquery-ui/ui/widgets/mouse.js';
import 'jquery-ui/ui/widgets/selectable.js';
import 'jquery-ui/ui/widgets/draggable.js';
import 'jquery-ui/ui/widgets/sortable.js';
import 'jquery.maskedinput/src/jquery.maskedinput.js';
import _ from 'underscore';
import 'pwstrength-bootstrap/dist/pwstrength-bootstrap.js';
import 'datatables.net/js/jquery.dataTables.js';
import 'select2';
/* jshint ignore:start */
import trumbowyg from 'trumbowyg';
/* jshint ignore:end */
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.js';
import TimeSeriesHistogram from "./graphs/TimeSeriesHistogram";
import StackedBarChart from "./graphs/StackedBarChart";
import LineGraph from "./graphs/LineGraph";
import Sunburst from "./graphs/Sunburst";
import Table from "./components/Table";

window.$ = $.noConflict();
window._ = _;

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$.trumbowyg.svgPath = '/images/trumbowyg.svg';

window.fixedEncodeURIComponent = function (str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
    });
};

$.fn.scrollParent = function () {
    let overflowRegex = /(auto|scroll)/,
        position = this.css("position"),
        excludeStaticParent = position === "absolute",
        scrollParent = this.parents().filter(function () {
            const parent = $(this);
            if (excludeStaticParent && parent.css("position") === "static") {
                return false;
            }
            return (overflowRegex).test(parent.css("overflow") + parent.css("overflow-y") + parent.css("overflow-x"));
        }).eq(0);

    return position === "fixed" || !scrollParent.length ? $(this[0].ownerDocument || document) : scrollParent;
};

/**
 * Validate required fields
 * @returns {boolean}
 */
$.fn.isFormValid = function () {
    const errors = [];

    //Clear
    $('.aero-require-error').removeClass('aero-require-error');
    $('.aero-error-box').remove();

    $(this).find('.aero-required').each(function () {
        //Clear error
        $(this).removeClass('aero-require-error');

        //Check error
        if ($(this).val() === "") {
            if (errors.length === 0) {
                errors.push(Lang.requirede);
            }
            $(this).addClass('aero-require-error');
        }
    });

    const pwregex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    $(this).find('[type="password"]').each(function () {
        const val = $(this).val();
        if (val !== '') {
            let err_exists = $(this).parents('label > .field-error-msg').length;
            if (!pwregex.test(val) && !err_exists) {
                $(this).parents('label').prepend(`<div class="field-error-msg">${Lang.passwordreq}</div>`);
            }
        }
    });

    if (errors.length > 0) {
        $(this).prepend(`<div class="aero-error-box"><ul><li>${errors.join('</li><li>')}</li></ul></div>`);
        return false;
    }

    return true;
};

$.fn.aeroSerialize = function () {
    var o = {};
    var a = this.serializeArray();

    $.each(a, function () {
        var name = this.name.replace("aero_", "");

        if (o[name] !== undefined) {
            if (!o[name].push) {
                o[name] = [o[this.name]];
            }
            o[name].push(this.value || '');
        } else {
            o[name] = this.value || '';
        }
    });
    return o;
};

$.fn.serializeObject = function () {
    const self = this;
    let json = {};
    const push_counters = {};
    const patterns = {
        "validate": /^[a-zA-Z][a-zA-Z0-9_]{0,256}(?:\[(?:\d*|[a-zA-Z0-9_]+)\]){0,256}$/,
        "key": /[a-zA-Z0-9_]+|(?=\[\])/g,
        "push": /^$/,
        "fixed": /^\d+$/,
        "named": /^[a-zA-Z0-9_]+$/
    };


    this.build = function (base, key, value) {
        base[key] = value;
        return base;
    };

    this.push_counter = function (key) {
        if (push_counters[key] === undefined) {
            push_counters[key] = 0;
        }
        return push_counters[key]++;
    };

    $.each($(this).serializeArray(), function () {
        // skip invalid keys
        if (!patterns.validate.test(this.name)) {
            return;
        }

        let k,
            keys = this.name.match(patterns.key),
            merge = this.value,
            reverse_key = this.name;

        while ((k = keys.pop()) !== undefined) {
            // adjust reverse_key
            reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), '');

            if (k.match(patterns.push)) {
                // push
                merge = self.build([], self.push_counter(reverse_key), merge);
            } else if (k.match(patterns.fixed)) {
                // fixed
                merge = self.build([], k, merge);
            } else if (k.match(patterns.named)) {
                // named
                merge = self.build({}, k, merge);
            }
        }

        json = $.extend(true, json, merge);
    });

    return json;
};

window.graphs = {
    StackedBarChart: StackedBarChart,
    LineGraph: LineGraph,
    Sunburst: Sunburst,
    TimeSeriesHistogram: TimeSeriesHistogram,
};

window.components = {
    Table: Table
};
